import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";
import React from "react";

export const DataPersonIcon = ({
  width = "24",
  height = "24",
  color = "#1C3C6C",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 16.25C18 13.9225 13.6613 12.75 11.5 12.75C9.33875 12.75 5 13.9225 5 16.25V18H18V16.25Z"
          fill={color}
        />
        <path
          d="M14.75 8.5C14.75 10.4425 13.3038 12 11.5 12C10.638 12 9.8114 11.6313 9.2019 10.9749C8.59241 10.3185 8.25 9.42826 8.25 8.5C8.25 7.57174 8.59241 6.6815 9.2019 6.02513C9.8114 5.36875 10.638 5 11.5 5C13.3038 5 14.75 6.5575 14.75 8.5Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
